<template>
  <div class="search-fertilizers">
    <!-- <div class="search-wrapper">
      <div class="icon h-i-center">
        <i class="material-icons">
          search
        </i>
      </div>
      <input class="h-empty-input" type="text" placeholder="Search" @change="updateSearch">
    </div> -->
    <!-- <Search @input="updateSearch" :secDelay="1"/> -->
    <search-bar
      type="text"
      :placeholder="$ml.get(`Search`)"
      @input="updateSearch"
      :value="value"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import Search from '@/components/common/SearchInput';

export default {
  created() {
    this.updateSearch('');
  },
  computed: {
    ...mapGetters({
      type: 'fertilizers/getType',
      id: 'fertilizers/getId',
      // page: 'fertilizers/getPage'
    }),
  },
  methods: {
    updateSearch (val) {
      this.$store.commit('fertilizers/saveSearch', val);
      this.$store.commit('fertilizers/savePage', 0);

      this.$store.dispatch('fertilizers/getFertilizers');
      // if (this.$route.params.page == 0) {
      // } else {
      //   this.$router.push(`/dashboard/fertilizers/${this.type}/${this.id}`);
      // }
    },
  },
  // components: {
  //   Search
  // },
}
</script>

<style lang="scss" scoped>
  .search-fertilizers {
    border-bottom-width: 0;
    padding-bottom: 16px;
    width: 100%;
    max-width: 100%;
    .search {
      padding: 0;
    }
  }
</style>
